module.exports = __webpack_public_path__ + "ecae91f83076777898e1408514a563e4.svg";